import { createSlice } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'

const initialState = {
    error: false,
    errorPhrase: "",
    info: false,
    infoPhrase: "",
    hubPage: "",
    showAlert: false,
    alertType: '',
    paymentRequired: false
}

const hubSlice = createSlice({
    name: "hub",
    initialState,
    reducers: {
        hubError: (state,action) => {
            state.error = true
            state.errorPhrase = action.payload.errorPhrase
        },
        hubInfo: (state,action) => {
            state.info = true
            state.infoPhrase = action.payload.infoPhrase
        },
        setHubPage: (state,action) => {
            state.hubPage = action.payload.hubPage
        },
        resetHubPage: (state) => {
            state.hubPage = initialState.hubPage
        },
        resetAlert: (state) => {
            state.error = initialState.error
            state.errorPhrase = initialState.errorPhrase
            state.info = initialState.info
            state.infoPhrase = initialState.infoPhrase
        },
        showAlert: (state,action) => {
            state.showAlert = true
            state.alertType = action.payload.alertType
        },
        hideAlert: (state) => {
            state.showAlert = false
            state.alertType = ''
        },
        reset: state => initialState,
    },
})

const persistConfig = {
    key: 'hub',
    storage: storage,
    whitelist: ['hubPage']
}

export const { hubError, hubInfo, setHubPage, resetHubPage, resetAlert, showAlert, hideAlert, reset } = hubSlice.actions
export default persistReducer(persistConfig,hubSlice.reducer)